module.exports = __webpack_public_path__ + "img/title-2.4121b87b.png";